import axios from "axios";
import { getAllLanguagesApi } from "../../api";

export const getAllLanguagesRequest = () => axios.get(getAllLanguagesApi());
